import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { faLocationCrosshairs } from '@fortawesome/pro-solid-svg-icons/faLocationCrosshairs';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemOutgoingTrackingIdMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	if (
		mailItemData?.outgoingTrackingId === '' ||
		mailItemData?.outgoingTrackingId === null ||
		mailItemData?.outgoingTrackingId === undefined
	) {
		return null;
	}

	return (
		<ContentBlock
			title={t('mailItem.labels.trackingIdOut')}
			content={mailItemData?.outgoingTrackingId}
			iconContent={{ icon: faLocationCrosshairs, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemOutgoingTrackingIdMeta };
